import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import Text from "../../../../components/theme/text/Text";
import { tokens } from '../../../../theme';

import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";
// import Text from "../../../../components/theme/text/Text";

import { useEffect, useState } from "react";
import OrdersCard from "../../../../components/global/cards/orders/OrdersCard";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShCopyButton from '../../../../components/theme/ShCopy';
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";

import { useRef } from "react";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader';
import { general_states } from '../../../../utils/staticEnums';
import { ORDER_FILTER_KEYS } from '../../../../components/global/DataGrid/Filter';
import MpAddBolReplenishment from '../../../../components/global/ModalsProgression/MpAddBolReplenishment/MpAddBolReplenishment';
import { useFindAllBolreplenishmentsQuery } from '../../../../newapi/webshop/bolreplenishmentSlice';
import ShDoubleTextSkeleton from '../../../../components/theme/skeleton/ShDoubleTextSkeleton';
import SpBolReplenishmentDetails  from '../../../../components/global/Sidepanels/SpBolReplenishmentDetails/SpBolReplenishmentDetails';
import { BolLvbRelationCard } from '../../../../components/global/cards/orders/BolLvbCard';
import ShDataGrid3 from '../../../../components/theme/datagrid3/ShDataGrid3';
import { RELATION_ORDERS_BOLLVB } from '../family';


const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1}>
            <ButtonGroup version={2}>
                <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} endIcon={<AddIcon/>} variant="contained" onClick={() => props.setOpen(true)}>{t("new_replenishment")}</Shbutton>
            </ButtonGroup>
            {/* <Shbutton isSidepanel color="primary" variant="contained" endIcon={<AddIcon/>}>New</Shbutton> */}
        </Box>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    // filter: [ORDER_FILTER_KEYS.STATE],
};

const OutboundBolView = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);

    // const [config,setConfig] = useState({[ORDER_FILTER_KEYS.STATE.backend_key]:[general_states.SNOOZE]});


    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions setOpen={setOpen}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);
    
    const [itemId, setItemId] = useState();
    const itemIdRef = useRef(itemId);
    
    const getReplenishmentDetails = (params) => {
        if (!params) return;
    
        const newItemId = parseInt(params.row.id);
        // Only update state if the orderId has actually changed
        if (itemIdRef.current !== newItemId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setItemId(newItemId);
            itemIdRef.current = newItemId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {field: "reference", headerName: t("reference"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.reference}</Text>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.reference}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {
            field: "state",
            headerName: t("status"),
            flex:1,
            // filter: ORDER_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const stateColors = {
                    "open": "grey",
                    "bol_announced": theme.palette.mode === "dark" ? "blue" : "primary",
                    "bol_in_transit": "purple",
                    "bol_arrived_at_wh": "orange",
                    "bol_in_progress_at_wh": "pink",
                    "bol_done": "green",
                    "bol_cancelled": "red",
                    "approved": theme.palette.mode === "dark" ? "blue" : "primary",
                    "rejected": "red",
                    "completed": "green",
                    "cancelled": "red"
                };

                const variant = stateColors[params.row.state] || "grey";

                return <ShLabel size={32} palette="normal" variant={variant}>{t(params.row.state)}</ShLabel>;
              }
        },
        {field: "webshopcredentials", headerName: t("channel_name"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{params.row.webshopcredentials?.description ?? t("self_created")}</Text>)
            }
        },
        {field: "order", headerName: t("order"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{params.row.order?.barcode}</Text>)
            }
        },
        {
            field: "expectedDeliveryDate", 
            headerName: t("deliverydates"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {

                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelcolor = "grey";
                let expected = params.row.expectedDeliveryDate ? new Date(params.row.expectedDeliveryDate) : null;
                let planned = params.row.plannedShipmentDate ? new Date(params.row.plannedShipmentDate) : null;
              
                if(planned) {
                        labelcolor = "green";
                }
                else if(expected) {
                    // When sent is not filled and planned >= now: blue
                    if(expected.getTime() >= Date.now()) {
                        labelcolor = theme.palette.mode === "dark" ? "blue" : "primary";
                    }
                    // When sent is not filled and planned < now: red
                    else if(expected.getTime() < Date.now()) {
                        labelcolor = "red";
                    }
                } else {
                    labelcolor = "grey";    
                }
              
                return !planned && !expected ? (<Box></Box>) 
                : (
                    <ShLabel size={32} fitted variant={labelcolor} palette="normal">
                        {!planned && expected.toLocaleDateString(i18n.language)}
                        {planned && planned.toLocaleDateString(i18n.language)}
                    </ShLabel>
                );
            }
        },
        {field: "amountOfLines", headerName: t("lines_count"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }
                return (
                    <Box display="flex" gap={4}>
                        <Text>
                            <b>
                                {params.row.amountOfLines}
                            </b>
                            &nbsp;
                            <Text light>
                                {t("products")}
                            </Text>
                        </Text>
                        <Text>
                            <b>
                                {params.row.amountOfItems}
                            </b>
                            &nbsp;
                            <Text light>
                                {t("items")}
                            </Text>
                        </Text>
                    </Box>
                );
            }
        },
        
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <BolLvbRelationCard 
                        onClick={() => getReplenishmentDetails(params)} 
                        skeleton={params.row.skeleton ?? false} 
                        {...params.row}  
                    />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3
                key={theme.palette.mode}
                gridKey={RELATION_ORDERS_BOLLVB.BOLLVB.gridKey}
                content={useFindAllBolreplenishmentsQuery}
                // config={config}
                gridActions={<GridActions setOpen={setOpen}></GridActions>} 
                title={t('bol_replenishments') }
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                onRowClick={getReplenishmentDetails}
            >
                    
            </ShDataGrid3>

            {spLoading && 
                <SpBolReplenishmentDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    itemId={itemId}
                    // data={orderData}
                /> 
            }

            <MpAddBolReplenishment open={open} handleClose={handleClose}/>
        </Box>
    );
}
export default OutboundBolView;